export const sxStyled = () => {
  return {
    sxDialog: {
      '& .MuiDialog-container': {
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      },

      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        p: 0,
        margin: 0,
        maxHeight: '100vh',
        maxWidth: '100vw',
        overflow: 'hidden',
        boxSizing: 'border-box',
      },

      '& .MuiPaper-elevation24': {
        boxShadow: 'none',
      },
    },

    sxCircularProgress: {
      width: 60,
      height: 60,
      overflow: 'hidden',
    },
    getLogoStyle: {
      display: 'block',
      objectFit: 'contain',
      width: '100%',
      height: 'auto',
      maxWidth: '90vw',
      maxHeight: '90vh',
    },
  };
};
